import { CompanyCard } from '@/modules/companies/components/CompanyCard';
import type { CompanyApi } from '@/modules/companies/types';

interface CompanyListProps {
  companies: CompanyApi[];
}

export const CompanyList = ({ companies }: CompanyListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {companies.map((company) => (
        <CompanyCard key={company.id} company={company} />
      ))}
    </div>
  );
};
